module.exports = __webpack_public_path__ + "static/media/1.009d4200.png";